import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../theme';
import {
  BTN_DEFAULT_SELECTOR,
  borderRadius,
  flex1,
  spaceBetween,
} from '../../styles/mixins';

export const useConfirmOrderButtonsStyles = createStyles(({ token }) => ({
  confirmOrderButtons: {
    '> .ant-col': {
      ...spaceBetween(ThemeSpaces.SPACE_XXS, 'horizontal'),
    },
    '.ant-btn': {
      borderRadius: 0,
      padding: 0,
    },
    '.ant-btn.ant-btn--round-left': {
      ...borderRadius({ side: 'left' }),
    },
    '.ant-btn.ant-btn--round-right': {
      ...borderRadius({ side: 'right' }),
    },
    '.ant-btn.ant-btn__font-plus-1': {
      [`@media (min-width: ${token.screenLGMin}px)`]: {
        fontSize: token.fontSizeHeading1,
      },
      [`@media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          fontSize: token.fontSizeHeading3,
        },
      [`@media (max-width: ${token.screenXSMax}px)`]: {
        fontSize: token.fontSizeHeading4,
      },

      '&.ant-btn-loading': {
        '&, &:active, &:focus, &[disabled]': {
          [`@media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenMDMax}px)`]:
            {
              fontSize: token.fontSizeHeading4,
            },
          [`@media (max-width: ${token.screenXSMax}px)`]: {
            fontSize: token.fontSizeLG,
          },
        },
      },
    },
    '.ant-btn.ant-btn__font-plus-2': {
      [`@media (min-width: ${token.screenLGMin}px)`]: {
        fontSize: token.fontSizeHeading1,
      },
      [`@media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          fontSize: ThemeFont.FONT_SIZE_HEADING_2_5,
        },
      [`@media (max-width: ${token.screenXSMax}px)`]: {
        fontSize: token.fontSizeHeading3,
      },

      '&.ant-btn-loading': {
        '&, &:active, &:focus, &[disabled]': {
          [`@media (max-width: ${token.screenXSMax}px)`]: {
            fontSize: ThemeFont.FONT_SIZE_HEADING_3_5,
          },
        },
      },
    },
    '> .ant-col.ant-col__small': {
      [`@media (min-width: ${token.screenLGMin}px)`]: {
        width: 140,
      },
      [`@media (max-width: ${token.screenMDMax}px)`]: {
        width: 66,
      },
    },
    '> .ant-col.ant-col__big': {
      ...flex1(),
    },
    '.ant-btn-lg': {
      display: 'block',
      width: '100%',

      [`@media (min-width: ${token.screenLGMin}px)`]: {
        height: 80,
      },
      [`@media (max-width: ${token.screenMDMax}px)`]: {
        height: 60,
      },

      '&.ant-btn-primary': {
        boxShadow: `0 1px 2px ${ThemeColors.COLOR_GREY_BLUISH5}, 6px 6px 30px ${hexToRgbaWithAlpha(
          ThemeColors.COLOR_GREY_BLUISH,
          0.5
        )}`,
        fontWeight: 'bold',
        borderWidth: 0,

        '&.ant-btn-loading': {
          '&, &:active, &:focus, &[disabled]': {
            backgroundColor: ThemeColors.COLOR_ORANGE3,
            borderWidth: 0,
            color: token.colorWhite,
          },
        },
      },
      [`&${BTN_DEFAULT_SELECTOR}`]: {
        borderWidth: 2,
        boxShadow: `2px 0 0 ${ThemeColors.COLOR_WHITE2}`,

        [`@media (min-width: ${token.screenLGMin}px)`]: {
          fontSize: ThemeFont.FONT_SIZE_HEADING_3_5,
        },
        [`@media (max-width: ${token.screenMDMax}px)`]: {
          fontSize: token.fontSizeHeading4,
        },
      },
    },
  },
}));
